import type { OfferChoice } from "../protocol.js";

/** Rarity tier → accent color (cards, pills, glows). */
export const RARITY_COLOR: Record<NonNullable<OfferChoice["rarity"]>, string> = {
  common: "#9aa7c0",
  rare: "#4aa3ff",
  epic: "#b06bff",
  legendary: "#ffb84a",
};

/** Upgrade kind → a card type badge (icon + label + accent). */
export const KIND_META: Record<
  NonNullable<OfferChoice["kind"]>,
  { label: string; icon: string; color: string }
> = {
  "new-power": { label: "New Power", icon: "✦", color: "#6fffa8" },
  "power-level": { label: "Power Up", icon: "▲", color: "#ffd24a" },
  passive: { label: "Passive", icon: "◆", color: "#7fb2ff" },
};

/** Extraction phase code (0 idle…4 failed) → accent color. */
export const EXTRACTION_COLOR = ["#55ccff", "#55ccff", "#ffc24d", "#6fffa8", "#ff7a7a"] as const;

/** mm:ss from ms. */
export const fmtClock = (ms: number): string => {
  const s = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(s / 60);
  return `${m}:${(s % 60).toString().padStart(2, "0")}`;
};
